module.exports = __webpack_public_path__ + "img/hzy.3c8aea16.png";